import React, { useState, useEffect  } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import { ToastContainer } from "react-toastify";
import { Edit, Trash2 } from "lucide-react";
import { BASE_URL } from "../Apis/apiConfig";

const AllInterest = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const [data, setData] = useState([]);
const [loading, setLoading] = useState(false);

 

const handleDelete = async (id) => {
  try {
    const response = await fetch(
      `${BASE_URL}/api/interest/delete-interest?interestId=${id}`,
      {
        method: "DELETE",
      }
    );

    if (!response.ok) {
      throw new Error("Failed to delete interest");
    }

    const result = await response.text();
    console.log(result);

    // Update UI after successful deletion
    setData((prevData) => prevData.filter((item) => item.id !== id));

  } catch (error) {
    console.error("Error deleting interest:", error);
  }
};



  useEffect(() => {
  fetchInterest();
}, []);

const handleEdit = (item) => {
  setEditData({
    interestId: item.interestId,
    interestRate: item.interestRate,
    fineFrequency: item.fineFrequency,
  });

  setIsModalOpen(true);
};

const [isModalOpen, setIsModalOpen] = useState(false);

const [editData, setEditData] = useState({
  interestId: "",
  interestRate: "",
  fineFrequency: "",
});

const fetchInterest = async () => {
  try {
    setLoading(true);

    const token = localStorage.getItem("token");
    const societyName = localStorage.getItem("society");
    const registrationNo = localStorage.getItem("societyRegNo");

    const response = await fetch(
      `${BASE_URL}/api/interest/get-interest?societyName=${societyName}&registrationNo=${registrationNo}`,
      {
        method: "Post",
        headers: {
          Authorization: `Bearer ${token}`, // optional if backend needs it
        },
      }
    );

    const result = await response.json();
    setData(result);
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

const handleUpdate = async () => {
  try {
    const token = localStorage.getItem("token");

    const response = await fetch(
      `${BASE_URL}/api/interest/edit-interest?interestId=${editData.interestId}&societyName=${localStorage.getItem("society")}&interestRate=${editData.interestRate}&interestType=${editData.fineFrequency}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const result = await response.text();

    if (response.ok) {
      alert("Interest updated successfully");
      setIsModalOpen(false);

      // 🔥 refresh list AFTER update
      fetchInterest();
    } else {
      alert("Update failed");
    }

  } catch (error) {
    console.log("Update error:", error);
  }
};

  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />

      <div className="main-layout">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

        <main className="content-area">
          <SubHeader />

          <div className="page-container">
            <div className="table-wrapper">
              <table className="table">
                <thead>
                  <tr>
                 <th style={{ color: "#2563eb" }}>ID</th>
                <th style={{ color: "#2563eb" }}>Interest Rate</th>
                 <th style={{ color: "#2563eb" }}>Fine Frequency</th>
                <th style={{ color: "#2563eb" }}>Actions</th>
                  </tr>
                </thead>

                <tbody>
                    {data.map((item) => (
                        <tr key={item.interestId}>
                        <td>{item.interestId}</td>
                        <td>{item.fineFrequency}</td>
                        <td>{item.interestRate} %</td>

                        <td>
                            <button className="edit-btn" onClick={() => handleEdit(item)}>
                    <Edit size={16} /> Edit
                    </button>

                            <button className="delete-btn" onClick={() => handleDelete(item.interestId)}>
                            <Trash2 size={16} /> Delete
                            </button>
                        </td>
                        </tr>
                    ))}
                </tbody>
              </table>

            </div>
  {isModalOpen && (
  <div className="modal-overlay">
    <div className="modal-box clean-modal">

      {/* Header */}
      <div className="modal-header">
        <h3>Edit Interest Rate</h3>
      </div>

      {/* Body */}
      <div className="modal-body">

        {/* Interest Rate */}
        <label>Interest Rate (%)</label>
        <input
          type="number"
          value={editData.interestRate || ""}
          onChange={(e) =>
            setEditData({
              ...editData,
              interestRate: e.target.value,
             
            })
          }
          placeholder="Enter interest rate"
        />

        {/* Interest Type (NEW FIELD) */}
         <label style={{ marginTop: "10px" }}>Fine Frequency</label>

<select
  value={editData.fineFrequency}
  onChange={(e) =>
    setEditData({
      ...editData,
      fineFrequency: e.target.value,
    })
  }
>
  <option value="">Select Frequency</option>
  <option value="DAY">Day</option>
  <option value="MONTH">Month</option>
  <option value="YEAR">Year</option>
</select>
      </div>

      {/* Footer */}
      <div className="modal-footer">
        <button className="save-btn" onClick={handleUpdate}>
          Save
        </button>

        <button
          className="cancel-btn"
          onClick={() => setIsModalOpen(false)}
        >
          Cancel
        </button>
      </div>

    </div>
  </div>
)}
            <ToastContainer />
          </div>
        </main>
      </div>

      {/* CSS */}
      <style>{`
        .page-container {
          padding: 20px;
        }

        .title {
          color: #2563eb;
          font-size: 22px;
          font-weight: 600;
          margin-bottom: 15px;
        }

        /* TABLE WRAPPER FOR RESPONSIVE SCROLL */
        .table-wrapper {
          width: 100%;
          overflow-x: auto;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.08);
        }

        .table {
          width: 100%;
          border-collapse: collapse;
          min-width: 500px;
        }

        th {
          background: #2563eb;
          color: #fff;
          text-align: left;
          padding: 12px;
          font-size: 14px;
        }

        td {
          padding: 12px;
          border-bottom: 1px solid #eee;
          font-size: 14px;
        }

        tr:hover {
          background: #f9fafb;
        }

        .edit-btn {
          background: #f59e0b;
          color: white;
          border: none;
          padding: 6px 10px;
          border-radius: 6px;
          margin-right: 8px;
          cursor: pointer;
          display: inline-flex;
          gap: 5px;
          align-items: center;
        }

        .delete-btn {
          background: #ef4444;
          color: white;
          border: none;
          padding: 6px 10px;
          border-radius: 6px;
          cursor: pointer;
          display: inline-flex;
          gap: 5px;
          align-items: center;
        }

        /* MOBILE RESPONSIVE */
        @media (max-width: 768px) {
          .page-container {
            padding: 10px;
          }

          .title {
            font-size: 18px;
            text-align: center;
          }

          td, th {
            font-size: 12px;
            padding: 10px;
          }

          .edit-btn,
          .delete-btn {
            padding: 5px 8px;
            font-size: 12px;
          }
        }

        .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.clean-modal {
  width: 350px;
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.15);
}

.modal-header {
  margin-bottom: 15px;
  text-align: center;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: #111;
}

.modal-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.modal-body label {
  font-size: 13px;
  color: #555;
}

.modal-body input {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  outline: none;
}

.modal-footer {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

.save-btn {
  background: #2563eb;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 6px;
  cursor: pointer;
  width: 48%;
}

.cancel-btn {
  background: #e5e7eb;
  color: #111;
  border: none;
  padding: 8px 15px;
  border-radius: 6px;
  cursor: pointer;
  width: 48%;
}
      `}</style>
    </div>
  );
};

export default AllInterest;